import {redirect} from 'react-router-dom';
import {exchangeTokenSlice} from '../store/slices/exchange_token_slice';
import {store as AppStore} from '../store/store';

export async function signOutLoader(store: typeof AppStore) {
    localStorage.removeItem('token');
    store.dispatch(exchangeTokenSlice.actions.logout());
    return redirect('/login');
}
